<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li v-if="MyfavoritethingsruleData.acf?.title"><router-link to="/myfavoritethings/rule">{{ MyfavoritethingsruleData.acf?.title }}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="cms">
      <div class="container">
        <div class="cms-cont">
          <h2 v-if="MyfavoritethingsruleData.acf?.title && !isLoading">{{ MyfavoritethingsruleData.acf?.title }}</h2>
          <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 39px;">
            <PuSkeleton style="height: 30px;" :count="1"/>
          </div>
          <div v-if="MyfavoritethingsruleData.acf?.html_text && !isLoading" class="cms-cont__top rule_text_custom" v-html="MyfavoritethingsruleData.acf?.html_text"></div>
          <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 46px;">
            <PuSkeleton style="height: 15px;" :count="25"/>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { RouterLink } from 'vue-router';
import { getUrl, metaData } from '@/utils/helper';

export default {
  name: 'Myfavoritethingsrule',
  components: {},
  data() {
    return {
      MyfavoritethingsruleData: {},
      isLoading: true,
    }
  },
  computed: {
  },
  methods: {
  },
  created() {
    this.isLoading = true;
    getUrl(`/others_privacypolicy/${process.env.VUE_APP_ID_PHOTOPOSTINGRULE}`)
    .then((response) => {
      this.MyfavoritethingsruleData = response.data;

      metaData(
        `${this.MyfavoritethingsruleData.acf?.title ? this.MyfavoritethingsruleData.acf?.title : '写真投稿に関する規約'} | HARUMIFLAGタウンポータル`,
        '中央区晴海・HARUMIFLAGのMY FAVORITE THINGSの写真投稿に関する規約についてのご案内ページです。',
        'HARUMIFLAGタウンポータル',
        'article'
      )
      
      this.isLoading = false;
    })
    .catch((e) => {
      console.log(e);
      this.$router.push('/timeout')
    });
  },
}
</script>